// Keep this in parity with cms-footer.styl and old agenda footer
// Disable ESLint for SUI Variables because we don't want this attached to SUI
/* eslint-disable @splashthat/sui-colors-only */
import styled from 'styled-components';

export const FooterContainer = styled.div`
    background-color: #1a1a1a;
    color: #ffffff;
    padding: 2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: Lato, sans-serif;
`;

export const ButtonGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const Delimiter = styled.span`
    margin: auto;
    pointer-events: none;
`;

export const FooterButton = styled.a`
    border: none;
    outline: none;
    font: inherit;
    background: none;
    cursor: pointer;

    font-size: 0.8125rem;
    line-height: 1.7;
    letter-spacing: 0.1em;
    color: #ffffff;
    font-weight: 700;
    border-radius: 2px;
    transition: all 500ms linear;
    padding: 0 10px;
    text-decoration: none;
    margin-top: 5px;

    &:hover,
    &:active {
        color: #1a1a1a;
        background: #e5e5e5;
        transition: none;
    }

    &:focus {
        outline-style: auto;
    }
`;

export const CalendarWrapper = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    margin-right: 2.5rem;

    @media (max-width: 600px) {
        margin-right: 0;
        flex-direction: column;
        align-items: center;
    }
`;

export const CalendarIconWrapper = styled.div`
    font-size: 1.625rem;
    line-height: 11px;
    margin: 0 6px;
    cursor: pointer;
    display: flex;
    align-items: center;

    svg {
        width: 26px;
        height: 26px;
        fill: currentColor;
        transition: opacity 0.2s ease;
    }

    &:hover svg {
        opacity: 0.8;
    }
`;

export const CalendarLinks = styled.div`
    font-size: 0.75rem;
    color: #fff;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: ${({ show }) => (show ? '160px' : '0')};
    right: 100%;
    overflow: hidden;
    white-space: nowrap;
    transition: width 0.15s linear;

    a {
        color: #fff !important;
        text-decoration: none;
        margin-right: 8px;

        &:hover {
            opacity: 0.8 !important;
        }
    }

    @media (max-width: 600px) {
        position: absolute;
        top: -41px;
        left: 50%;
        transform: translate(-50%, -50%);
        width: ${({ show }) => (show ? '125px' : '0')};
        height: ${({ show }) => (show ? 'auto' : '0')};
        font-size: 0.8125rem;
        line-height: 23px;
        text-align: center;
        background: #000;
        border-radius: 4px 4px 0 0;
        padding: ${({ show }) => (show ? '7px' : '0')};
        white-space: normal;
        word-spacing: 4px;
        overflow: hidden;
        z-index: 6;
    }
`;
